import { render } from "./IntroView.vue?vue&type=template&id=20aff87e&scoped=true"
import script from "./IntroView.vue?vue&type=script&lang=js"
export * from "./IntroView.vue?vue&type=script&lang=js"

import "./IntroView.vue?vue&type=style&index=0&id=20aff87e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aff87e"]])

export default __exports__